import React, { useRef, useState, useEffect } from 'react';
import DataTable from "react-data-table-component";
import {useForm} from 'react-hook-form';
import moment from 'moment-timezone';

import {
    Alert,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Card,
    CardBody,
    CardTitle,
    CardSubtitle,
    CardHeader,
    Container,
    CardText,
    Button,
    Row,
    Col,
    Badge,
    Input,
    Image,
    Form,
    FormGroup,
    Label,
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
    Table,
    TabContent, TabPane, Nav, NavItem, NavLink, 
} from "reactstrap";

import Header from 'components/Headers/Header';
import { connect } from 'react-redux';
import { useDispatch } from 'react-redux';
import Swal from 'sweetalert2'
import { getUserData } from 'redux/UserAuthentication/LoginActions';
import { app, db } from "../../firebase";
import { getDocs, getDoc, setDoc, addDoc, collection, query, where, onSnapshot, doc, orderBy, limit } from "firebase/firestore";
import { deleteCommunityComment } from 'redux/Community/CommunityAction';
import Comment from 'components/Community/Comment';
const ManageComments = (props) => {
    const dispatch = useDispatch();
    const [data, setData]= useState([]);
    const [search, setSearch]= useState('');
    const [filter, setFilter] = useState([]);
    const [commentId, setCommentId] = useState('');
    const [commentItem, setCommentITem] = useState([]);

    //Modal Behaviour 
    const [modal, setModal] = useState(false);
    const modalToggle = () => setModal(!modal);
    const [backdrop, setBackdrop] = useState(true);


    //Show posts in realtime
    useEffect(() => {
        const unsub = onSnapshot(query(collection(db, "communityComments"), orderBy("updatedAt", "desc")), (snapshot) => {
            setData(
                snapshot.docs.map(
                    (doc) => (
                        { ...doc.data(), commentDocId: doc.id }
                    )
                )
            )
            setFilter(
                snapshot.docs.map(
                    (doc) => (
                        { ...doc.data(), commentDocId: doc.id }
                    )
                )
            )
        },(error) => {
            
        }
        );
        return unsub
    }, []);

    const truncate = (str,n) => {
        return (str.length > n) ? str.slice(0, n-1) + ' ...' : str;
    }

    const columns= [
        {
            name:"#",
            selector: (row) => row.commentDocId,
            wrap: true,
        },
        {
            name:"Content",
            selector: (row) => truncate(row.comment,40),
            wrap: true,
        },
        {
            name:"Files",
            selector: (row) => (
                row.fileContent.length ? 
                     row.fileContent.map((f, i) => {
                         return (
                             f.file.mimeType == "video/mp4"
                            ?
                                <video controls width="50" height="50" style={{ backgroundColor: '#000' }} >
                                    <source
                                        type={f.file.mimeType}
                                        src={'https://storage.googleapis.com/pre-dental-tracker.appspot.com/community-upload/' + f.name}
                                    />
                                </video>
                            :
                            <img width="50" height="50" src={'https://storage.googleapis.com/pre-dental-tracker.appspot.com/community-upload/' + f.name} /> 
                        )
                    })
                : 'No Files... '
               
            ),
            wrap: true,
        },
        {
            name:"Date",
            selector:(row)=>moment(row.updatedAt).format("MMM Do YY"),
        },
        {
            name:"Action",
            cell: (row) => (
                <>
                    <a className="btn btn-sm btn-primary" onClick={e => onClickViewComment(e, row.commentDocId, row)} ><i className="fas fa-eye"></i> View</a> 
                    {
                        props.userDetails.admin === true || props.userDetails.admin == 'true'
                            ? 
                            <a className="btn btn-sm btn-warning" onClick={()=>handleDelete(row.commentDocId)}><i className="fas fa-trash"></i> Delete</a>
                        : ''     
                    }
                   
                  
                </>
               
            )
        }

    ];

    useEffect(()=>{
        const result= data.filter((item)=>{
            return item.comment.toLowerCase().match(search.toLocaleLowerCase());
        });
        setFilter(result);
    }, [search]);
    
      //On Click Edit Post
    const onClickViewComment = async (e, commentid, item) => {
        const docRef = doc(db, "communityComments", commentid);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            let citem = docSnap.data();
            citem['commentid'] = commentid
            // setItem(commentItem)
        } else {
        // docSnap.data() will be undefined in this case
            console.log("No such document!");
        }
        e.preventDefault();
        setCommentId(commentid)
        setCommentITem(item)
        setBackdrop(true);
        setModal(true)
        
    
    }

    const handleDelete = (val) => {
        
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonColor: '#3085d6',
            confirmButtonColor: '#d33'
        }).then((result) => {
           
            if (result.isConfirmed) {
                dispatch(deleteCommunityComment({ commentid: val }))
                if (modal) {
                    setModal(false)
                }
            }
        }) 
       
    }

    const tableHeaderstyle = {
        headCells: {
            style: {
                fontWeight: "bold",
                fontSize: "14px",
                backgroundColor: "#ccc"

            },
        }
    }

    useEffect(() => {

        if(props.deleteCommunityComment.loading){
            Swal.fire({
                allowOutsideClick : false,
                didOpen: () => {
                    Swal.showLoading()
                    
                }
            });
        }
        else{
            if (props.deleteCommunityComment.deletecommunitycomment.length) {
                Swal.fire({
                    title: 'Success!',
                    text: 'Successfully deleted!',
                    icon : 'success',
                    timer: 3000
                })
          }
          else if (typeof props.deleteCommunityComment.error !== "undefined") {
            Swal.fire({
              title: 'Failed!',
              text: 'Something went wrong!',
              icon : 'error',
              timer: 3000
            })
          }
        }
    
    }, [props.deleteCommunityComment])

    return (  
        <>
  
            <Card className="shadow">
                <CardHeader className="border-0">
                    Manage Community Comments              
                </CardHeader>
                <CardBody>
                    {
                        data.length ?
                 
                        <DataTable 
                            // customStyles={ tableHeaderstyle}
                            columns={columns}
                            data={filter}
                            pagination
                            wrap
                            // selectableRows
                            // fixedHeader
                            selectableRowsHighlight
                            highlightOnHover
                        
                            subHeader
                            subHeaderComponent={
                                <input type="text"
                                className="w-25 form-control"
                                placeholder="Search a keyword content..."
                                value={ search}
                                onChange={(e)=>setSearch(e.target.value)}
                                />
                            }
                            subHeaderAlign="right"  
                            />
                         : <Alert color="primary"> No data available .</Alert>
                       }
                    
                </CardBody>
            </Card>         
            <Modal isOpen={modal} toggle={modalToggle}  backdrop={backdrop} size="lg">
                <ModalHeader toggle={modalToggle}>{ 'Comment ID: '+commentId }</ModalHeader>
                <ModalBody>
                    {
                        commentItem ?
                            <Comment
                                key={commentId}
                                item={commentItem}
                                postDetails=""
                            />
                           
                            // console.log(commentItem)
                        : ''
                  }
                  
                </ModalBody>
                <ModalFooter className="">
                    <Button color="secondary" onClick={modalToggle}>
                        Cancel
                    </Button>
                    <Button  color="danger" onClick={e => handleDelete(commentId)}>
                        Delete
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    )
  
}

const mapStateToProps = state  => {
    return {
        userDetails: state.loginAuth.userDetails,
        deleteCommunityComment : state.deleteCommunityComment
    }
      
}

export default connect(mapStateToProps)(ManageComments)

